import React from "react";
import './index.css';
import logo from "../../../assets/images/schmodelplain-withR-white.png";
import {Link} from "react-router-dom";

function Instructions() {
    return (
        <div className="instructions-container">
            <div className='instructions-header'>
                <img
                    src={logo} alt="logo"
                    style={{height: "32%", cursor: "pointer"}}
                    onClick={() => window.location.href = process.env.REACT_APP_COM_URL}
                />
            </div>
            <div className="instructions-main">
                Membership is only available to applicants  <br/>
                with a notable Instagram presence.<br/>
                <br/>
                It will be linked to your Instagram account.<br/>
                <br/>
                To apply for a membership,<br/>
                simply follow these two steps:<br/>
                <br/>
                <span style={{ fontFamily: 'Open Sans', fontWeight: 400, color: "#B08D57" }}>Step 1. </span>
                From your Instagram app, log in to<br/>
                <p style={{ fontFamily: 'Playfair Display', fontWeight: 500 }}>
                    your&nbsp;
                    <span style={{ fontFamily: 'Playfair Display', fontWeight: 700 }}>main account</span>
                    &nbsp;and follow
                </p>
                <span
                    style={{ cursor: "pointer", textDecoration: "underline", textUnderlineOffset: '2px', fontFamily: 'Open Sans', fontWeight: 400, color: "#B08D57" }}
                    onClick={() => {
                        window.location.href=process.env.REACT_APP_INSTAGRAM_URL
                    }}
                >
                        @schmodel.studio
                    </span>
                <br/>
                <span style={{ fontFamily: 'Open Sans', fontWeight: 400, color: "#B08D57" }}>Step 2. </span>
                Click the link in our bio to apply.
            </div>
            <div className="instructions-footer">
                <div
                    className="w-full flex justify-center items-center"
                    style={{ fontFamily: 'Open Sans', fontWeight: 400, color: "#B08D57", fontSize: 12 }}
                >
                    <Link to="/terms-of-use" style={{ textDecoration: "underline" }}>Terms of Use</Link>,&nbsp;
                    <Link to="/privacy-policy" style={{ textDecoration: "underline" }}>Privacy Policy</Link>&nbsp;&&nbsp;
                    <Link to="/cookie-policy" style={{ textDecoration: "underline" }}>Cookie Policy</Link>
                </div>
            </div>
        </div>
    );
}

export default Instructions;